import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { TableCell, TableRow, IconButton, Button } from '@mui/material';
import { ListingThumbnail } from '../../../shared-components';
import DeleteIcon from '@mui/icons-material/Delete';
import useTranslation from '../../../hooks/useTranslation'


const Store = (props) => {
  const { t } = useTranslation();
  return (
    <TableRow key={props.id}>
      <TableCell component="th" scope="row">
        <Link to={{ pathname: `/admin/stores/${props.id}`, state: { storeName: props.name } }} > {props.index} </Link>
      </TableCell>
      <ListingThumbnail image={props.logo} />
      <TableCell component="th" scope="row">
        <Link to={{ pathname: `/admin/stores/${props.id}`, state: { storeName: props.name } }} > {props.name} </Link>
      </TableCell>
      <TableCell component="th" scope="row">{props.company_name}</TableCell>
      <TableCell>{props.is_live ? '✔' : ''}</TableCell>
      <TableCell>
        {props.deletedAt ? (
          <>
            <Button
              size="small"
              variant="text"
              color="primary"
              sx={{ textTransform: 'none', fontWeight: 500 }}
              onClick={() => props.triggerRestoreDialog(props.id)}
            >
              {t('labels.store.restore')}
            </Button>
            <Button
              size="small"
              variant="text"
              color="error"
              sx={{ textTransform: 'none', fontWeight: 500 }}
              onClick={() => props.onDelete(props.id, true)}
            >
              {t('labels.store.permanent_delete')}
            </Button>
          </>
        ) : (
          <IconButton color="error" size="small" onClick={() => props.onDelete(props.id)}>
            <DeleteIcon />
          </IconButton>
        )}
      </TableCell>
    </TableRow>
  );
};

Store.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  company_name: PropTypes.string,
  is_live: PropTypes.bool,
  logo: PropTypes.string,
  index: PropTypes.number,
  onDelete: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired
};

export default Store;
